// Package imports
import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Button, ListItemButton, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import IconButton from '@mui/material/IconButton';


// Custom imports
// import Styles from "../../style/Styles";

// Component
const EnumerationCard = (props) => {

    // State
    const [expanded, setExpanded] = useState(false);


    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    // JSX template
    return (
        <Grid item xs={6} sx={{}}>
            <Box sx={{ borderRadius: 5, border:1, borderColor: '#D9D9D9', background: 'linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)'}}>
                <CardContent>
                    <ListItemText
                        sx={{ m: 0, px: 0, }}
                        primary={<Typography variant="body1"
                            sx={{ color: '#5f5600ff', fontWeight: 'bold', textAlign: 'left','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}>
                            {props.keydata.name}
                            <span sx={{ color: '#9e9e9e', fontSize: '0.7rem', textAlign: 'left', marginLeft: 5,'@media (min-width: 1636px)': {fontSize: '0.8rem'}}}>
                                ({props.keydata.data.length} members)
                            </span>
                        </Typography>}
                        secondary={<Typography variant="body2" sx={{ color: '#5f5600ff', textAlign: 'left', fontWeight: '500', fontSize: '0.9rem','@media (min-width: 1636px)': {fontSize: '1.2rem'} }}>
                            {props.keydata.description}
                        </Typography>} />
                </CardContent>
                <CardActions disableSpacing sx={{}}>
                    <ListItemText 
                        sx={{ m: 0, px: 0, py: 0.3, ml: 1 }} 
                        primary={<Typography variant="body2" sx={{ color: '#9e9e9e', textAlign: 'left', textTransform: 'uppercase', fontWeight: '500', fontSize: '0.8rem','@media (min-width: 1636px)': {fontSize: '1rem'} }}>
                            {props.keydata.type}
                        </Typography>} />
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon sx={{fontSize: '1.5vw'}}/>
                    </ExpandMore>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent sx={{ borderBottomLeftRadius: 20, borderBottomRightRadius: 20, background: '#fffef5ff' }}>
                        <Grid container spacing={0}>
                            <Grid item xs={4}>
                                <Typography sx={{ color: '#5f5600ff', fontWeight: '500', fontSize: '0.9rem', textAlign: 'left','@media (min-width: 1636px)': {fontSize: '1.2rem'}}}>
                                    Order of items
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography sx={{ color: '#5f5600ff', fontWeight: '500', fontSize: '0.9rem', textAlign: 'left','@media (min-width: 1636px)': {fontSize: '1.2rem'} }}>
                                    : {props.keydata.data.join(" , ")}
                                </Typography>
                            </Grid>
                        </Grid>
                        {(props.keydata.type != 'Global') &&
                            <Grid
                                container
                                spacing={0}
                                sx={{
                                    pt: 2,
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center'
                                }}>
                                <Grid item onClick={() => {props.onPressDelete(props.keydata)}}>
                                    <IconButton aria-label="comment" sx={{ mr: 2, fontWeight: '600', borderRadius: 10, px: 2,color:'#d32f2f', '&:hover': { backgroundColor: '#5f5600ff', color: '#FFFFFF' } }}>
                                        <DeleteOutlinedIcon  sx={{fontSize: '1.6vw'}}/>
                                    </IconButton>
                                </Grid>
                                <Grid item onClick={() => {props.onPressEdit(props.keydata)}}>
                                    <Button sx={{ color: '#5f5600ff', backgroundColor: '#FFFFFF', fontWeight: '600', borderRadius: 10, px: 2, '&:hover': { backgroundColor: '#5f5600ff', color: '#FFFFFF' }, '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                        Edit
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </CardContent>
                </Collapse>
            </Box>
        </Grid>
    );
}

// Styles

export default EnumerationCard;